<template>
    <el-container class="home-container">
      <el-header >
        <div>
          <img src= "../assets/logo.png" class="user-avatar" alt="">
          <span>机器人统一管理平台</span>
        </div>
        <el-button type='primary'  @click="logout">退出</el-button>
      </el-header>
      <!--页面主题区-->
      <el-container>
            <!-- 侧边栏 -->
          <el-aside :width="isCollapse ? '64':'200'">
            <div class="toggle-button" @click="toggleCollapse()">|||</div>
            <!-- 侧边栏菜单区  active-text-color 目标颜色 -->
            <el-menu background-color="#333744"  text-color="#fff"  active-text-color="#409EFF" :unique-opened="true" :collapse="isCollapse" 
             :collapse-transition="false"    router   default-active="activePath"  >
            <!-- 一级菜单 -->
            <el-submenu :index="item.id+''"  v-for="item in menulist" :key="item.id" >
            <!-- 一级菜单末班区域 -->
            <template slot="title">
                <!-- 图标 -->
                <i :class="inconsObject[item.id]"></i>
                <!-- 文本 -->
                <span>{{item.name}}</span>
            </template>
             <!-- 二级菜单末班区域 -->
             <el-menu-item :index="'/'+subItem.path" v-for="subItem in item.children" :key="subItem.id"   @click="saveNavState('/'+subItem.path)">
                  <template slot="title">
                  <!-- 图标 -->
                  <i class="el-icon-menu"></i>
                  <!-- 文本 -->
                  <span>{{subItem.name}}</span>
                  </template>
             </el-menu-item>
          </el-submenu>
         
        </el-menu>
      </el-aside>
      <!-- 右侧内容主题 -->
      <el-main>
          <router-view  ></router-view>
      </el-main>
      </el-container>
    </el-container>
</template>   
<script>
  export default {
    name: 'Home',
    data(){
      return {
        //左侧菜单序列
        menulist:[],
        activePath:'',
        inconsObject: {
          '1':'el-icon-s-shop',
          '2':'el-icon-camera',
          '3':'el-icon-message-solid',
          '4':'el-icon-s-cooperation',
          '5':'el-icon-s-custom'
        },
        isCollapse:false,
      }
    },
   
    created(){
      this.getMenuList();
      this.activePath=window.sessionStorage.getItem('activePath')
    },
    methods: {
       logout(){
                this.$http.get("/user/logout") .then(successResponse => {
                    if (successResponse.data.code == 200) {
                        window.sessionStorage.clear();
                        var cookies= this.$cookies.keys()
                        for(var i=0;i<cookies.length;i++) {
                          this.$cookies.remove(cookies[i]);
                        }
                        return this.$router.push('/login') 
                    }
                }).catch(failResponse => {

                })
               
      },
      async getMenuList(){ await  this.$http.get("/menu/userMenu") .then(successResponse => {
                    if (successResponse.data.code === 200) {
                        console.log(successResponse.data)
                        this.menulist=successResponse.data.result;
                    }
                    if(successResponse.data.code === 408){
                     // this.$message.error(successResponse.data.message);
                      window.sessionStorage.clear();
                      var cookies= this.$cookies.keys()
                      for(var i=0;i<cookies.length;i++) {
                        this.$cookies.remove(cookies[i]);
                      }
                      this.$router.push('/login') 
                      return 
                    }
                }).catch(failResponse => {

                })
      },
      toggleCollapse(){
          this.isCollapse=! this.isCollapse;
      },
       //保持连接的激活状态
      saveNavState(activePath){
        window.sessionStorage.setItem('activePath',activePath);
        this.activePath=activePath;
      },
    }
  }
</script>

<style  lang="less" scoped>
.el-header{
  background-color: #373d41;

  display: flex;
  //左右贴标对齐
  justify-content: space-between;

  //清空header左侧空白
  padding-left: 0;
  //标签居中
  align-items: center;

  color: #fff;
  font-size: 20px;
  > div{
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}
.el-aside{
  background-color: #333744;
  .el-menu{
    border-right: none;
  }
}
.el-main{
   background-color: #EAEDF1;
}
.home-container{
  height: 100%;
}
.user-avatar {
          cursor: pointer;
          width:8%;
          height: 18%;
        }
.toggle-button{
  background-color: #4A5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue